import React from 'react';

const BookList = ({ books, onEdit, onDelete }) => {
  if (!Array.isArray(books) || books.length === 0) {
    return (
      <div className="empty-state">
        <p>📚 Книг пока нет</p>
        <p className="empty-hint">Нажмите "Добавить книгу" чтобы добавить первую книгу</p>
      </div>
    );
  }

  return (
    <div className="items-list">
      {books.map(book => (
        <div key={book.id} className="item-card">
          {book.cover && (
            <img src={book.cover} alt={book.title} className="item-image" />
          )}
          <div className="item-content">
            <h3>{book.title}</h3>
            <p className="item-authors">
              {book.authors && Array.isArray(book.authors) ? 
                book.authors.map(a => a.full_name || `${a.last_name} ${a.first_name}`).join(', ') :
                'Автор не указан'
              }
            </p>
            <div className="item-meta">
              <span className="badge badge-language">{book.language}</span>
              <span className="badge badge-format">{book.file_format}</span>
              {book.is_featured && <span className="badge badge-featured">Рекомендуемая</span>}
              <span className="meta-text">⭐ {book.rating} | 👁 {book.views_count} | ⬇️ {book.downloads_count}</span>
            </div>
          </div>
          <div className="item-actions">
            <button className="btn-edit" onClick={() => onEdit(book)}>✏️ Изменить</button>
            <button className="btn-delete" onClick={() => onDelete(book.slug)}>🗑️ Удалить</button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BookList;
